class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  

  onToggle() {
    //  if (!this.animations) this.animations = this.content.getAnimations();
    if (!this.animations) this.animations = this.content.getAnimations?.() || [];

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}


if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure);
}


class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();

    //   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);

    this.header = document.querySelector('.header-wrapper');

    this.detailsElement = this.mainDetailsToggle;
    this.hoverTimeout = null;

    this.mainMegaMenuContent = this.detailsElement.querySelector('.mega-menu__content');
    this.leftLinks = this.detailsElement.querySelectorAll('.mega-menu__link--level-2');
    this.rightContents = this.detailsElement.querySelectorAll('.mega-menu__right-content');
    this.defaultContent = this.detailsElement.querySelector('#default-mega-menu-content');
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;

    this.dataset.section = this.closest('.shopify-section')?.id?.replace('shopify-section-', '') || '';
    this.style.display = 'block';

    this.setupEventListeners();

    if (this.detailsElement.hasAttribute('open')) {
      this.showDefaultContent();
    }
  }

  setupEventListeners() {
    this.leftLinks.forEach(link => {
      link.addEventListener('mouseenter', this.onLinkHover.bind(this));
      link.addEventListener('focus', this.onLinkHover.bind(this));
    });

    if (this.mainMegaMenuContent) {
      this.mainMegaMenuContent.addEventListener('mouseenter', this.onMegaMenuContentEnter.bind(this));
      this.mainMegaMenuContent.addEventListener('mouseleave', this.onMegaMenuContentLeave.bind(this));
    }

    this.detailsElement.addEventListener('mouseleave', this.onMegaMenuContentLeave.bind(this));
  }

  onToggle() {
    super.onToggle(); 

    if (!this.header) return;
    this.header.preventHide = this.detailsElement.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    if (this.detailsElement.hasAttribute('open')) {
      this.showDefaultContent();
    } else {
      this.hideAllRightContents();
      clearTimeout(this.hoverTimeout);
    }
  }

  showDefaultContent() {
    this.hideAllRightContents();
    if (this.defaultContent) {
      this.defaultContent.classList.add('active-right-content');
    }
  }

  hideAllRightContents() {
    this.rightContents.forEach(content => {
      content.classList.remove('active-right-content');
    });
  }

  onLinkHover(event) {
    const targetHandle = event.currentTarget.dataset.megaMenuTarget;
    const targetId = `${targetHandle}-content`;

    this.hideAllRightContents();

    const targetContent = this.detailsElement.querySelector(`#${targetId}`);
    if (targetContent) {
      targetContent.classList.add('active-right-content');
    }
  }

  onMegaMenuContentEnter() {
    clearTimeout(this.hoverTimeout);
  }

  onMegaMenuContentLeave() {
    this.hoverTimeout = setTimeout(() => {
      if (this.detailsElement.hasAttribute('open')) {
        this.showDefaultContent();
      }
    }, 150);
  }
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu);
}

